<div class="widget-settings d-sm-flex flex-column" [formGroup]="scheduleSettingsForm">
    <h3>Schedule Settings</h3>
    <div class="d-sm-flex flex-column">
        <mat-slide-toggle formControlName="scheduleEnabled">
            Schedule Enabled
        </mat-slide-toggle>
        @if (scheduleSettingsForm.get('scheduleEnabled')?.value) {
            <div class="d-flex flex-column">
                <mat-form-field appearance="fill" class="full-width">
                    <mat-label>Scheduling Mode</mat-label>
                    <mat-select formControlName="schedulingMode">
                        <mat-option value="Interval">Interval</mat-option>
                        <mat-option value="Cron">Cron</mat-option>
                    </mat-select>
                </mat-form-field>
                @if (scheduleSettingsForm.get('schedulingMode')?.value === 'Interval') {
                    <mat-form-field appearance="fill" class="full-width">
                        <mat-label>Interval Minutes</mat-label>
                        <input formControlName="intervalMinutes" matInput placeholder="Enter interval in minutes"
                               type="number">
                    </mat-form-field>
                }
                @if (scheduleSettingsForm.get('schedulingMode')?.value === 'Cron') {
                    <mat-form-field appearance="fill" class="full-width">
                        <mat-label>Cron Expression</mat-label>
                        <input formControlName="cronExpression" matInput placeholder="Enter cron expression">
                        @if (scheduleSettingsForm.get('cronExpression')?.hasError('pattern') && scheduleSettingsForm.get('cronExpression')?.touched) {
                            <mat-error>
                                Enter a valid cron expression
                            </mat-error>
                        }
                    </mat-form-field>
                }
                <mat-form-field appearance="fill" class="full-width">
                    <mat-label>Start Date (UTC)</mat-label>
                    <input formControlName="startDateUtc" matInput type="datetime-local">
                </mat-form-field>
                <mat-form-field appearance="fill" class="full-width">
                    <mat-label>End Date (UTC)</mat-label>
                    <input formControlName="endDateUtc" matInput type="datetime-local">
                </mat-form-field>
                @if (scheduleSettingsForm.hasError('scheduleModeRequired') || scheduleSettingsForm.hasError('scheduleIntervalInvalid') || scheduleSettingsForm.hasError('scheduleCronInvalid') || scheduleSettingsForm.hasError('scheduleDateInvalid') || scheduleSettingsForm.hasError('scheduleDateOrderInvalid')) {
                    <mat-error>
                        Velg en gyldig plan: intervall over null eller gyldig cron, og en startdato som ikke er etter sluttdatoen.
                    </mat-error>
                }
            </div>
        }
    </div>
</div>
